import { LessonDefinition } from "../../types";

const lesson: LessonDefinition = {
  id: "combine-narrative-and-interaction",
  courseId: "reports-from-audio",
  order: 2,
  title: "Combine recordings",
  subtitle: "A narrative plus an interaction",
  summary:
    "Upload your dictation and the interview into one case. The AI reads both and writes one report, in the order you arrange the files.",
  learn: [
    "Upload several files into one case",
    "Order the files chronologically so the narrative flows",
    "Know when the draft starts and what happens if one file fails",
  ],
  sceneId: "combine-narrative-and-interaction",
  tourId: "combine-narrative-and-interaction",
  minutes: 3,
  releasedAt: "2025-06-01T00:00:00.000Z",
  body: [
    {
      type: "paragraph",
      text: "The strongest reports usually come from two recordings: the interview itself (an interaction) and a short narrative where you dictate what you observed, the timeline, and the disposition. One case can hold up to 10 files.",
    },
    {
      type: "steps",
      items: [
        "Click **New Case**.",
        "Click **Upload Files** and drop in all the recordings at once, or add them one by one. **Previous Uploads** reuses a file from an earlier case.",
        "Set each row to **Narrative** or **Interaction**.",
        "Add speakers to the interaction rows.",
        "Drag the rows into the order things happened (\"Drag to reorder chronologically\"). Your dictation usually goes last.",
        "Open **Report Settings** if you want a template or a different **Report Detail Level**.",
        "Click **Upload (N files)**.",
      ],
    },
    {
      type: "paragraph",
      text: "Each file is transcribed on its own, and the draft starts only after every file has finished. A two-hour interview plus a two-minute narrative waits for the interview. Regular files upload from your browser one after another, so stay on the page until the upload progress completes. After that you can leave.",
    },
    {
      type: "callout",
      tone: "tip",
      text: "In your narrative file, say what an interview never captures: times, your arrival, what you saw, who was present, and the outcome. The interaction supplies the quotes and your dictation supplies the structure.",
    },
    {
      type: "callout",
      tone: "note",
      text: "If one file fails, the case shows an error instead of a partial draft. Open the case and use the recovery options in \"Cancel or recover\".",
    },
    {
      type: "paragraph",
      text: "Not sure which type a row should be? \"Audio types\" covers the choice and the defaults.",
    },
  ],
  related: ["narrative-vs-interaction-audio", "cancel-or-recover-an-upload", "regenerate-the-narrative"],
};

export default lesson;
